import type { TransactionType } from '@framework/constants/enums/transaction';

export const api = {
    invitationById: (id: string): string => `/api/invitations/${id}/`,
    submitPassword: (): string => '/api/authenticate/primary/password/prove/',
    resetPassword: (): string => '/api/authenticate/password_reset/init/',
    resetPasswordById: (id: string) => `/api/authenticate/password_reset/${id}/status/`,
    authenticationStatus: (): string => '/api/authenticate/status/',
    authenticationForget: (): string => '/api/authenticate/forget/',
    requestMtanEnroll: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/mtan-enroll/send/`,
    submitMtanEnroll: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/mtan-enroll/prove/`,
    requestMtan: (): string => '/api/authenticate/secondary/mtan/send/',
    requestMtanTransactions: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/mtan/send/`,
    submitMtan: (): string => '/api/authenticate/secondary/mtan/prove/',
    submitMtanTransactions: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/mtan/prove/`,
    submitTotp: (): string => '/api/authenticate/secondary/totp/prove/',
    requestOneTouchInit: (): string => '/api/authenticate/secondary/one_touch/init/',
    requestOneTouchStatus: (): string => '/api/authenticate/secondary/one_touch/status/',
    findSSOMethod: (): string => '/api/authenticate/methods/',
    transaction: (): string => '/api/transactions/',
    transactionById: (id: string): string => `/api/transactions/${id}/`,
    initializeOneTouch: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/one_touch/init/`,
    requestEmailCode: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/email/send/`,
    submitEmailCode: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/email/prove/`,
    initializeOneTouchEnroll: (type: TransactionType, id: string): string =>
        `/api/transactions/${type}/${id}/methods/onetouch-enroll/init/`
};
